import PropTypes from 'prop-types';
import React from 'react';
import Sidebar from '../Sidebar/SidebarContainer';
import Notification from '../Notification';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { getNotificationList } from "../../routes/notification/modules/notification";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showSidebar: true };
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  componentDidMount() {
    if (this.props.perms.includes('travel_management')) {
      this.props.getNotificationList()
    }
  }

  getCSS() {
    if (this.state.showSidebar) {
      return 'main-section';
    }
    return 'sidebargone main-section';
  }
  toggleSidebar() {
    this.setState(prevState => ({
      showSidebar: !prevState.showSidebar,
    }));
  }
  render() {
    return (
      <div className="container-fluid">
        <div className="row layout-wrapper">
          <Sidebar toggleActive={this.toggleSidebar} isActive={this.state.showSidebar} />
          <div className={this.getCSS()}>
            {
              this.props.perms.includes('travel_management') ?
                <div className="text-right" >
                  <Link to='/notifications' >
                    <i className="fa fa-bell" aria-hidden="true" style={{ fontSize: "30px" }} />
                  </Link>
                  <span className="badge badge-notify">{this.props.notification ? this.props.notification.notificationCount : 0}</span>
                </div> : null
            }
            {this.props.children}</div>
          <Notification />
        </div>
      </div>
    );
  }
}
Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

const mapDispatchToProps = {
  getNotificationList
}
const mapStateToProps = state => ({
  profile: state.auth.profile,
  notification: state.notification,
  perms: state.auth.perms
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);




// WEBPACK FOOTER //
// src/components/Layout/Layout.js